import { render, staticRenderFns } from "./ValesView.vue?vue&type=template&id=5987464c&scoped=true"
import script from "./ValesView.vue?vue&type=script&lang=js"
export * from "./ValesView.vue?vue&type=script&lang=js"
import style0 from "./ValesView.vue?vue&type=style&index=0&id=5987464c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987464c",
  null
  
)

export default component.exports